import { render, staticRenderFns } from "./globalVPopupImage.vue?vue&type=template&id=b640f390"
import script from "./globalVPopupImage.vue?vue&type=script&lang=js"
export * from "./globalVPopupImage.vue?vue&type=script&lang=js"
import style0 from "./globalVPopupImage.vue?vue&type=style&index=0&id=b640f390&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports